import { useScrollReveal } from '@/hooks/useScrollReveal';

const mediaItems = [
  {
    title: '触手漫画创作幕后',
    desc: '走进触手漫画作者的创作世界，了解从草稿到成品的全过程。',
    image: 'https://readdy.ai/api/search-image?query=Artist%20studio%20with%20dark%20atmosphere%20and%20crimson%20accents%2C%20manga%20drawing%20tools%20on%20desk%2C%20creative%20workspace%2C%20cinematic%20lighting%2C%20mysterious%20ambiance%2C%20no%20text&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '12:38',
  },
  {
    title: '触手漫画名场面合集',
    desc: '触手题材漫画中最经典的战斗与剧情桥段，燃到停不下来。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20montage%20scene%20with%20crimson%20energy%20and%20dark%20flowing%20forms%2C%20dramatic%20cinematic%20composition%2C%20intense%20atmosphere%2C%20no%20text&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '25:14',
  },
  {
    title: '触手漫画年度盘点',
    desc: '回顾过去一年触手漫画的热门作品、口碑佳作与行业趋势。',
    image: 'https://readdy.ai/api/search-image?query=Awards%20ceremony%20with%20dark%20elegant%20atmosphere%2C%20crimson%20and%20gold%20accents%2C%20premium%20cinematic%20composition%2C%20mysterious%20mood%2C%20no%20text&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '18:42',
  },
  {
    title: '触手漫画入门指南',
    desc: '触手漫画新人必看！从零开始了解触手题材漫画的魅力世界。',
    image: 'https://readdy.ai/api/search-image?query=Educational%20guide%20scene%20with%20dark%20atmospheric%20aesthetic%2C%20crimson%20highlights%2C%20organized%20composition%2C%20cinematic%20lighting%2C%20welcoming%20but%20mysterious%20mood%2C%20no%20text&width=800&height=450&seq=media-04&orientation=landscape',
    duration: '08:55',
  },
];

export default function MediaSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);

  return (
    <section id="media" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/60 border border-accent-200/50 mb-4">
            <i className="ri-film-line text-accent-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-accent-700 whitespace-nowrap">独家内容 · 深度解读</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精彩内容
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            触手漫画相关的精选内容与独家解读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <MediaCard key={idx} item={item} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

function MediaCard({ item, idx }: { item: typeof mediaItems[0]; idx: number }) {
  const { ref, visible } = useScrollReveal(0.06);

  return (
    <a
      ref={ref}
      href="#media"
      className={`group block bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-300 transition-all overflow-hidden cursor-pointer ${
        visible ? `animate-fade-in-up animate-stagger-${idx + 1}` : 'animate-initial-hidden'
      }`}
    >
      <div className="relative h-36 md:h-40 overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center">
          <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors">
            <i className="ri-play-fill text-lg ml-0.5"></i>
          </div>
        </div>
        <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded whitespace-nowrap">
          {item.duration}
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1.5 line-clamp-2">{item.desc}</p>
      </div>
    </a>
  );
}